import { useMemo, useState, useRef, useEffect, useCallback } from 'react';
import './Landing.sass';
import Slider from 'react-slick';
// import { sampleNfts } from '../tools/fakeData';
import { Link } from 'react-router-dom';
import PrevArrow from '../icons/PrevArrow';
import NextArrow from '../icons/NextArrow';
// import selectArrow from '../assets/select-arrow.svg';
// import imagePreview from '../assets/image-preview.svg';
import Pagination from '../components/Pagination';
import { chunk, map } from 'underscore';
import { useWindowSize } from 'react-use';
import useCollections from '../hooks/useCollections';
// import useAssets from '../hooks/useAssetsBatch';
import useCheckVideo from '../hooks/useCheckVideo';
import useModal from '../hooks/useModal';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/zh-tw';
import { useTranslation } from 'react-i18next';

import Meta from '../components/Meta';

const getVideoId = (url) => {
	const regex = /^https:\/\/www\.(youtube|youtube-nocookie)\.com\/(embed\/|watch\?v=)([a-zA-Z0-9_-]{11})(\?si=[a-zA-Z0-9_-]+)?$/;
	const m = regex.exec(url);
	if (m !== null) {
		return m[3];
	}
	return null;
}

const checkYouTubeVideo = (urlToValidate) => {
	// 正規式
	const regex = /^https:\/\/www\.(youtube|youtube-nocookie)\.com\/(embed\/|watch\?v=)([a-zA-Z0-9_-]{11})(\?si=[a-zA-Z0-9_-]+)?$/;

	// 驗證
	if (regex.test(urlToValidate)) {
		return true;
	}
	
	return false;
};

function getSpotlightNfts(nfts, n) {
	if (nfts === undefined) return [];
	const shuffled = [...nfts].sort(() => 0.5 - Math.random());
	return shuffled.slice(0, n);
}

const Nft = ({ nft }) => {
	const { t, i18n } = useTranslation();

	const { isVideo, mediaType, checkForVideo } = useCheckVideo();
	const { sendModal } = useModal();
	const loggedAddress = localStorage.getItem('walletAddress');

	useEffect(() => {
		if (nft[0].uri) checkForVideo(nft[0].uri);
	}, [nft[0].uri, checkForVideo]);

	const uniqueOwners = [...new Set(nft.map((v, i) => v.creatorInfo.walletAddress))].concat([...new Set(nft.map((v, i) => v.ownerInfo.walletAddress))]);

	let navLink = nft.length > 1 ? `/collection/${ nft[0].collectionId }` : `/collection/${ nft[0].collectionId }/${ nft[0].id }`, 
		subscribeOnly = !nft[0].collectionInfo.subscribeOnly || uniqueOwners.includes(loggedAddress), 
		coverImage = subscribeOnly ? nft[0].uri : nft[0].collectionInfo.uri, 
		collectionName = nft[0].collectionInfo.fullName, 
		nftName = nft[0].fullName;

	let avgValuePrice = map(nft, (v) => v.valuePrice);
	avgValuePrice = avgValuePrice.reduce((memo, num) => memo + num, 0) / avgValuePrice.length || 1;

	const content = <>
	<div className='zoom-wrapper'>
		<div className='cover' style={{ backgroundImage: `url(${coverImage})` }}>
			{subscribeOnly ? (
				isVideo ? (
					mediaType === 'audio' ? (
						<div
								className="image-wrap"
								style={{
									backgroundImage: `url(${nft[0].collectionInfo.uri})`,
									height: 315,
									width: '100%',
									backgroundSize: 'cover',
									backgroundPosition: 'center',
									marginBottom: 8
								}}
						/>
					) : (
						<video src={ `${nft[0].uri.replace(/\s/g, '')}#t=0.15`} preload='metadata' autoPlay muted controlsList="nodownload"></video>
					)
				) : (checkYouTubeVideo(nft[0].uri.replace(/\s/g, '')) ? (
					<iframe 
						className='image-wrap'
						width="560" 
						height="315" 
						src={`https://www.youtube.com/embed/${getVideoId(nft[0].uri.replace(/\s/g, ''))}`}
						title="YouTube video player" 
						frameBorder="0" 
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
						allowFullScreen>
					</iframe>
				) : null)
			) : (<span>{t('landing.third_section_card_subscriber_only')}</span>)}
		</div>
	</div>
	<div className='info-wrap'>
		<div className='row margin'>
			<div className='info-collection-name'> {collectionName} </div>
			<div className='nft-name'> {nftName} </div>
		</div>
		<div className='row flex-between'>
			<div className='price'>
				{Math.round(avgValuePrice * 100) / 100} P
			</div>
			<div className='stock'>
				{t('landing.third_section_card_listed_text_items')} <b>{ nft.length > 1 ? (
					`${ nft.length }/${ nft[0].parentAmount }`
				) : nft.length}</b>
			</div>
		</div>
	</div>
	</>;

	return (
		<div className='item'>
			<div className='content'>
				{ nft.length > 1 ? (
					<div className="listings" onClick={() => sendModal(`${ nftName }_Listings`, t('landing.third_section_card_listed_list_title'), nft)}>{ content }</div>) : (
					<Link to={ navLink }>{ content }</Link>
				) }
			</div>
		</div>
	)
}

const NftCard = ({ nft }) => {
	const { t, i18n } = useTranslation();
	const { isVideo, mediaType, checkForVideo } = useCheckVideo();
	
	useEffect(() => {
		if (nft.uri) checkForVideo(nft.uri);
	}, [nft.uri, checkForVideo]);

	const catOptions = [
		{ value: 'art', label: t('explore.panel_category_art') }, 
		{ value: 'gaming', label: t('explore.panel_category_gaming') }, 
		{ value: 'memberships', label: t('explore.panel_category_memberships') }, 
		{ value: 'education', label: t('explore.panel_category_education') }, 
		{ value: '', label: t('explore.panel_category_others') }
	];

	return (
		<div className='item'>
			<div className='content'>
				<Link to={ `/collection/${nft.id}` }>
					<div className='zoom-wrapper'>
						<div className='cover' style={{ backgroundImage: `url(${nft.uri})` }} onContextMenu={(e) => e.preventDefault()}>
							{isVideo ? (
									mediaType === 'audio' ? (
										<div
												className="image-wrap"
												style={{
													backgroundImage: `url(${nft.uri})`,
													height: 315,
													width: '100%',
													backgroundSize: 'cover',
													backgroundPosition: 'center',
													marginBottom: 8
												}}
										/>
									) : (
										<video src={ `${nft[0].uri.replace(/\s/g, '')}#t=0.15`} preload='metadata' autoPlay muted controlsList="nodownload"></video>
									)
								) : (checkYouTubeVideo(nft.uri.replace(/\s/g, '')) ? (
								<iframe 
									className='image-wrap'
									width="560" 
									height="315" 
									src={nft.uri.replace(/\s/g, '')}
									title="YouTube video player" 
									frameBorder="0" 
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
									allowFullScreen>
								</iframe>
							) : null)}
						</div>
					</div>
					<div className='info-wrap'>
						<div className='row margin'>
							{/* <div className='info-collection-name'> {catOptions.find(el => el.value == nft.category).label} </div> */}
							<div className='nft-name'> {nft.fullName} </div>
						</div>
						<div className='row flex-between'>
							<div className='price'>
								<div style={{fontWeight: 'normal'}}><small>{t('landing.second_section_text_items')}</small></div>
								<b>{nft.onSellAmount}/{nft.totalCount}</b>
							</div>
							<div className='price'>
								<div style={{fontWeight: 'normal'}}><small>{t('landing.second_section_text_date')}</small></div>
								<b>{dayjs(nft.createdAt).fromNow()}</b>
							</div>
						</div>
					</div>
				</Link>
			</div>
		</div>
	)
}

const Prev = (props) => {
	return <PrevArrow {...props} />;
};

const Next = (props) => {
	return <NextArrow {...props} />;
};

const Landing = () => {

	const _ = require('lodash');
	const { t, i18n } = useTranslation();
	dayjs.extend(relativeTime);
	dayjs.locale(i18n.language);

	const { collections } = useCollections();
	// const { assetsBatch: assets, getAssetsBatch: getAssets } = useAssets();

	const spotlightSettings = useMemo(() => {
		return {
			arrows: true,
			prevArrow: <Prev />,
			nextArrow: <Next />,
			autoplay: true,
			autoplaySpeed: 8000,
			infinite: true,
			fade: true,
			speed: 1000,
			dots: true,
			customPaging: function (i) {
				return (
					<div className='nav-dot'>
						<div className='dot'></div>
					</div>
				);
			},
		};
	}, []);

	const collectionsSettings = useMemo(() => {
		const slidesToShow = Math.min(4, collections.length);
		return {
			arrows: true,
			prevArrow: <Prev slidesToShow={slidesToShow} slideLength={collections.length} />,
			nextArrow: <Next slidesToShow={slidesToShow} slideLength={collections.length} />,
			autoplay: false,
			infinite: true,
			speed: 1000,
			dots: true,
			customPaging: function () {
				return (
					<div className='nav-dot'>
						<div className='dot'></div>
					</div>
				);
			},
			slidesToShow: slidesToShow,
			slidesToScroll: slidesToShow,
			responsive: [
				{
					breakpoint: 766,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				},
			],
		};
	}, [collections.length]);

	// const [filter, setFilter] = useState('all');
	// const [sort, setSort] = useState('createdAtDescending');
	const [currentPage, setCurrentPage] = useState(1);

	const { width } = useWindowSize();

	const itemsPerPage = useMemo(() => {
		if (width >= 768) return 12;
		return 6;
	}, [width]);

	const pages = useMemo(() => {
		return chunk(collections, itemsPerPage);
	}, [itemsPerPage, collections]);

	const currentPageList = useMemo(() => {
		if (pages.length) return pages[currentPage - 1];
		return [];
	}, [currentPage, pages]);

	const nftSection = useRef();

	const [nftSectionTop, setNftSectionTop] = useState(0);

	useEffect(() => {
		let offset;

		if (width > 1366) offset = 75;
		if (width <= 1366 && width >= 768) offset = Math.round(75 / 1366 * width);
		if (width < 768) offset = Math.round(50 / 375 * width);

		setNftSectionTop(nftSection?.current?.offsetTop - offset);
	}, [nftSection?.current?.offsetTop, width]);

	// const [sortBy, setSortBy] = useState('createdAt');
	// const [sortDirection, setSortDirection] = useState('ASC');
	// const [filterCollection, setFilterCollection] = useState('');

	// useEffect(() => {
	// 	switch (sort) {
	// 		case 'createdAtAscending':
	// 			setSortBy('createdAt');
	// 			setSortDirection('ASC');
	// 			break;

	// 		case 'createdAtDescending':
	// 			setSortBy('createdAt');
	// 			setSortDirection('DESC');
	// 			break;

	// 		case 'priceAscending':
	// 			setSortBy('valuePrice');
	// 			setSortDirection('ASC');
	// 			break;

	// 		case 'priceDescending':
	// 			setSortBy('valuePrice');
	// 			setSortDirection('DESC');
	// 			break;
	// 	}
	// }, [sort]);

	// useEffect(() => {
	// 	switch (filter) {
	// 		case 'all':
	// 			setFilterCollection('');
	// 			break;

	// 		default:
	// 			setFilterCollection(filter);
	// 			break;
	// 	}
	// }, [filter]);

	// useEffect(() => {
	// 	getAssets({ sortBy, sortDirection, collectionId: filterCollection, groupBy: 1 });
	// }, [sortBy, sortDirection, filterCollection, getAssets]);

	return (
		<>
			<Meta metaTitle='UniFunn 共學園地' metaDescription='' metaKeyword='' />
			<div id='Landing'>
				<section className='spotlight'>
					<div className='slider-wrap'>
						<Slider className='slider' {...spotlightSettings}>
							{getSpotlightNfts(collections, 4).map((nft, index) => {
								return (
									<div className='slide' key={nft.id + index}>
										<div className='image-wraper' to={`/collection/${nft.id}`} >
											<img src={nft.uri} alt='' />
										</div>
										<div className='collection-name'>{t('landing.first_section_title')}</div>
										<div className='nft-name'>{nft.fullName}</div>
									</div>
								);
							})}
						</Slider>
					</div>

					<div className='intro'>
						<h1 className="title">
							<div className="text">UniFunn 共學園地</div>
							{/* <div className="text">商機無限UniFunn</div> */}
						</h1>
						<p className="description">
							嚴選趣味性、教育性兼備的優質原創內容。
							在這裡聽的每一首歌、讀的每一本書、看的每一段影片、參加的每一個活動，
							都能豐富孩子的學習歷程。
							<br/>
							<br/>
							📢 活動公告: <br/>
							《阿甯咕又闖禍了 YA~》音樂劇有聲繪本
							<ol>
								<li>
									<b>UniFunn 直購</b><br/>
									請填寫表單: <a href="https://forms.gle/xsAYkoidDG2BnvYKA" target="_blank" style={{fontWeight: 600}}>https://forms.gle/xsAYkoidDG2BnvYKA</a><br/>
									我們將於收到表單及款項後，為您寄送實體繪本、開通有聲書 & 歌曲雲端收聽權限。
								</li>
								<li>
									<b>其他通路購買</b><br/>
									請註冊 UniFunn 會員、填寫相同表單並出示購買證明，我們將為您開通有聲書 & 歌曲雲端收聽權限。
								</li>
							</ol>
						</p>
					</div>
				</section>

				{/* <section className='collections'>
					<h2>{t('landing.second_section_title')}</h2>

					<div className='slider-wrap'>
						{collections?.length ? (
							<Slider className='slider' {...collectionsSettings}>
								{ collections.map((collection, index) => {
									return (
										<div className='slide' key={collection.id + index}>
											<Link to={`/collection/${collection.id}`}>
												<div className='content'>
													<div className='zoom-wrapper'>
														<div className='cover' style={{ backgroundImage: `url(${collection.uri})` }}/>
													</div>
													<div className='info-wrap'>
														<div className='name'>{collection.fullName}</div>
														<div className='flex'>
															<div className='flex-column'>
																<span className='info-title'>{t('landing.second_section_text_items')}</span>
																<span className='info-content'>{collection.onSellAmount}/{collection.totalCount}</span>
															</div>
															<div className='flex-column'>
																<span className='info-title'>{t('landing.second_section_text_date')}</span>
																<span className='info-content'>{dayjs(collection.createdAt).fromNow()}</span>
															</div>
														</div>
													</div>
												</div>
											</Link>
										</div>
									);
								}) }
							</Slider>
						) : null}
					</div>
				</section> */}

				<div className='monetization-block'>Google ad</div>

				{/* <section className='nfts' ref={nftSection}>
					<h2>{t('landing.third_section_title')}</h2>

					<div className='controls'>
						<div className='select-wrap'>
							<select defaultValue={filter} style={{ backgroundImage: `url(${selectArrow})` }} onChange={(e) => { setFilter(e.target.value) }}>
								<option value='all'>{t('landing.third_section_select_cat_all')}</option>
								{collections.map((collection, index) => {
									return (
										<option value={collection.id} key={collection.id + index + 'option'}>{collection.fullName}</option>
									)
								})}
							</select>
						</div>

						<div className='select-wrap'>
							<select defaultValue={sort} style={{ backgroundImage: `url(${selectArrow})` }} onChange={(e) => { setSort(e.target.value) }}>
								<option value='createdAtDescending'>{t('landing.third_section_select_sort_new_old')}</option>
								<option value='createdAtAscending'>{t('landing.third_section_select_sort_old_new')}</option>
								<option value='priceDescending'>{t('landing.third_section_select_sort_high_low')}</option>
								<option value='priceAscending'>{t('landing.third_section_select_sort_low_high')}</option>
							</select>
						</div>
					</div>

					<div className='list-wrap'>
						{currentPageList?.map((nft, index) => {
							return (
								<Nft key={index} nft={nft} />
							)
						})}
					</div>

					<Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} pageCount={pages.length} top={nftSectionTop} />
				</section>

				<div className='monetization-block'>Google ad</div> */}
				<section className='nfts' ref={nftSection}>
					<h2 style={{ marginBottom: '30px' }}>{t('landing.second_section_title')}</h2>
					<div className='list-wrap'>
						{currentPageList?.map((nft, index) => {
							return (
								<NftCard key={index} nft={nft} />
							)
						})}
					</div>
					<Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} pageCount={pages.length} top={nftSectionTop} />
				</section>
				<div className='monetization-block'>Google ad</div>
			</div>
		</>
	);
};

export default Landing;
